import {combineReducers} from 'redux';
import currentProgressOnboardingWizard from './currentProgressOnboardingWizard';
import userDetails from './userDetails';
import lang from './i18n';
import contracts from './contracts';
import DealInfo from './DealInfo';
import auth from './auth';
import banks from './banks'
import sendSms from './sendSmsStatus';
import sendBranch from './sendBranch';
import statusEditUser from  './sendEditUser';
import billRegistration from  './billRegistration';
import virtualMemberDetails from './authVirtualMember';

const rootReducer = combineReducers({
  currentProgressOnboardingWizard,
  userDetails,
  lang,
  contracts,
  DealInfo,
  auth,
  banks,
  sendSms,
  sendBranch,
  statusEditUser,
  billRegistration,
  virtualMemberDetails
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js